// extracted by mini-css-extract-plugin
export var linkText = "_nf-0";